import * as React from "react";

export function Whatsapp(props) {
  return (
    <svg
      width={57}
      height={57}
      viewBox="0 0 57 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_23_525)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M45.09 40.245c-.687 1.944-3.417 3.553-5.595 4.023-1.49.317-3.434.567-9.983-2.147-7.356-3.048-17.57-13.903-17.57-21.127 0-3.678 2.12-7.96 5.828-7.96 1.784 0 2.177.034 2.764 1.443.687 1.659 2.363 5.747 2.562 6.166.824 1.72-.837 2.725-2.043 4.222-.385.45-.82.938-.334 1.776.485.82 2.16 3.552 4.623 5.744 3.18 2.834 5.76 3.739 6.683 4.124.687.285 1.508.218 2.01-.318.635-.687 1.425-1.827 2.228-2.95.568-.804 1.289-.904 2.044-.62.51.178 6.994 3.189 7.267 3.67.203.351.203 2.01-.484 3.954zM28.506 0h-.015C12.78 0 0 12.783 0 28.5c0 6.232 2.01 12.014 5.426 16.703l-3.55 10.59 10.952-3.5A28.279 28.279 0 0028.506 57C44.218 57 57 44.217 57 28.5S44.218 0 28.506 0z"
          fill="#FAFAFA"
        />
      </g>
      <defs>
        <clipPath id="clip0_23_525">
          <path fill="#fff" d="M0 0H57V57H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
